import styled from 'styled-components'

export const PushRight = styled.div`
  display: flex;
  justify-content: flex-start;
`
